import localization from './localization';

export default {
    mypage: '/mypage',
    spotlight: '/profile',
    profile: '/profile',
    profileDocuments: '/profile/documents',

    findjobs: '/jobs',
    jobDetail: '/job',
    findcompanies: '/companies',

    resources: '/resources',

    apps: '/apps',
    favorites: '/favorites',

    assessments: '/assessments',
    assessmentCenter: '/center',
    assessmentsRedirect: '/redirect',

    careerPlanning: '/careerplanning',

    coursera: '/upskill',
    courseraCatalog: '/upskill/catalog',
    courseraMyCourses: '/upskill/my-courses',
    courseraChooseSubscription: '/upskill/join',
    courseraHowTo: '/upskill/how-to',

    plansAndBilling: '/plansandbilling',

    emailVerification: '/verify',
    recoverUser: '/recover',
    recoverPassword: '/recover-password',

    redirect: '/redirect',

    aboutGPTW: '/about-gptw',

    internalResources: '/resources/internal',

    calendar: '/calendar',
    book: '/book',
    documents: '/cvupload',
    cvs: '/cvs',
    referrals: '/referrals',

    activateUser: '/activate-user', // Might rename, imported user register flow.

    vfairsLegacy: '/vfairs',
    vfairLegacy: '/vfair',
    vfairsHomeLegacy: localization.isSchoolPlatform ? '/vfairs' : '/',

    vfairs: '/vevents',
    vfair: '/vevent',
    vfairsHome: localization.isSchoolPlatform ? '/vevents' : '/',

    schoolEvents: '/events',

    // Legacy routes
    tests: '/tests',
    cute: '/cut-e',
};
